export const translations = {
  'pt-BR': {
    // Navbar
    nav: {
      features: 'Recursos',
      integrations: 'Integrações',
      pricing: 'Preços',
      login: 'Entrar',
      getStarted: 'Começar agora',
    },
    // Hero
    hero: {
      title: 'Gere apps internos com IA',
      subtitle: 'Da ideia ao app em minutos.',
      description: 'Descreva o que você precisa, conecte seus dados e publique com governança.',
      privacyTitle: 'Governança e controle',
      privacyBlur: 'Segurança',
      privacySuffix: ' e compliance',
      privacyDesc: 'Permissões, auditoria e isolamento de ambientes. Seus dados continuam seus — com controle total de acesso.',
      newFeature: 'Novo:',
      newFeatureText: 'Geração de apps com IA e conectores',
      buildAgentsBlur: 'Construa do jeito que você quiser.',
      buildAgentsSuffix: '',
      buildAgentsDesc: 'Entregue em uma plataforma na qual você pode confiar.',
      introducingMultiAgent: 'Ganhe 50 créditos',
      betaWithCredits: 'BETA',
    },
    // Logo Cloud
    logoCloud: {
      title: 'Integrações poderosas para seu workflow',
      subtitle: 'Conecte-se com as ferramentas que sua equipe já usa. ClickUp, GitHub, Slack, Jira e muito mais.',
      cta: 'Ver todas as integrações',
    },
    // Perfect For Section
    perfectFor: {
      title: 'Apps para cada área',
      items: {
        crm: 'CRM',
        report: 'Relatório',
        contracts: 'Contratos',
        website: 'Website',
        mobile: 'App Mobile',
        dashboards: 'Dashboards',
        marketing: 'Marketing',
        seo: 'SEO',
        sales: 'Vendas',
        finance: 'Financeiro',
        hr: 'RH',
        onboarding: 'Onboarding',
        newsletter: 'Newsletter',
        blog: 'Blog',
        ecommerce: 'E-commerce',
        api: 'API',
        design_system: 'Design System',
        roadmap: 'Roadmap',
      },
    },
    // Integrations Section
    integrations: {
      title: 'Conecte dados, APIs e ferramentas',
      subtitle: 'Paladino conecta seus sistemas para que a IA gere apps e automações com contexto real.',
      connectorTitle: 'Conector Universal',
      connectorDesc: 'Conecte bancos, APIs e ferramentas internas — com permissões e auditoria.',
      connected: 'Conectado',
      seeAll: 'Ver todas as integrações →',
    },
    // AI Section
    ai: {
      label: 'App builder com IA',
      title: 'Um estúdio para gerar apps de ponta a ponta',
      subtitle: 'Do prompt ao app.',
      description: 'Gere UI, consultas, automações e permissões — tudo editável e pronto para produção.',
      learnMore: 'Saiba mais',
      assignTo: 'Atribuir para...',
      agent: 'Agente',
      selfDriving: 'Workflows executáveis',
      selfDrivingDesc: 'Automatize aprovações, sincronizações e tarefas com ações acionáveis.',
    },
    // Features
    features: {
      title: 'Criado para times que constroem',
      subtitle: 'Tudo que você precisa para criar apps internos e automações',
      prd: 'Apps e dashboards',
      prdDesc: 'Gere telas, tabelas, formulários e filtros em minutos.',
      specs: 'Lógica e integrações',
      specsDesc: 'Queries, APIs, webhooks e ações conectadas ao seu stack.',
      proposals: 'Governança',
      proposalsDesc: 'SSO, RBAC e auditoria para controle de acesso.',
      reports: 'Entrega',
      reportsDesc: 'Ambientes, versões e deploy com confiança.',
    },
    // Product Direction
    productDirection: {
      label: 'Construção e colaboração',
      title: 'Construa, revise e publique com controle',
      subtitle: 'Tudo centralizado em um único lugar.',
      description: 'Modele UI, lógica e dados com colaboração em tempo real e histórico de mudanças.',
      manageProjects: 'Ambientes e versões',
      manageProjectsDesc: 'Separe dev, staging e produção com mudanças rastreáveis.',
      projectUpdates: 'Colaboração em tempo real',
      projectUpdatesDesc: 'Edite telas e fluxos com seu time, sem perder consistência.',
      ideate: 'Do prompt à produção',
      ideateSubtitle: 'em uma única plataforma',
      collaborativeDocs: 'Componentes colaborativos',
      inlineComments: 'Comentários inline',
      textToIssue: 'Prompt para ação',
      initiatives: 'Módulos',
      initiativesDesc: 'Organize apps por módulos e domínios.',
      crossTeam: 'Colaboração cross-team',
      crossTeamDesc: 'Integre equipes de diferentes áreas.',
      milestones: 'Releases',
      milestonesDesc: 'Planeje versões e publique com segurança.',
      insights: 'Observabilidade',
      insightsDesc: 'Acompanhe logs, erros e auditoria.',
    },
    // Workflows
    workflows: {
      label: 'Workflows e integrações',
      title: 'Conecte',
      titleBreak: 'ferramentas e dados',
      description: 'Use conectores para gerar apps com dados reais e automações acionáveis.',
      customerRequests: 'Solicitações internas',
      customerRequestsTitle: 'Transforme pedidos em apps e fluxos',
      gitWorkflows: 'Entrega com Git',
      gitWorkflowsTitle: 'Versione, revise e publique mudanças',
      mobile: 'App Mobile',
      mobileTitle: 'Acesse e opere de qualquer lugar',
      asks: 'Aprovações e SLAs',
      asksTitle: 'Automatize etapas com rastreabilidade',
    },
    // CTA
    cta: {
      title: 'Construa apps. Entregue com confiança.',
      contactSales: 'Falar com vendas',
      getStarted: 'Começar agora',
    },
    // Features New (Tyce-style)
    featuresNew: {
      title: 'Como funciona',
      search: 'Projetar',
      searchTitle: 'Projete telas com prompts',
      searchDesc: 'Descreva o fluxo e o Paladino gera layout e componentes com consistência.',
      searchBullet1: 'Layouts responsivos e reutilizáveis',
      searchBullet2: 'Componentes prontos para dados',
      searchBullet3: 'Padrões de design e acessibilidade',
      searchBullet4: 'Edição total após gerar',
      searchPlaceholder: 'Buscar componentes...',
      generate: 'Gerar',
      generateTitle: 'Gere lógica, queries e ações',
      generateDesc: 'Crie consultas SQL, integrações e validações com base no seu schema e regras.',
      generateBullet1: 'SQL e APIs com sugestões',
      generateBullet2: 'Validações e regras de negócio',
      generateBullet3: 'Formulários, tabelas e filtros',
      generateBullet4: 'Código e ações editáveis',
      generateDocTitle: 'Nova tela: onboarding',
      generateAuto: 'Geração automática',
      analyze: 'Validar',
      analyzeTitle: 'Teste e refine com IA',
      analyzeDesc: 'Simule casos, detecte edge cases e melhore UX, permissões e performance.',
      analyzeBullet1: 'Testes de fluxo e casos extremos',
      analyzeBullet2: 'Revisão de permissões e acesso',
      analyzeBullet3: 'Sugestões de performance',
      analyzeDocTitle: 'Revisão do app',
      analyzeComplete: 'Pronto para produção',
      analyzeSuggestion: '"Sugestão: adicione validação de campos obrigatórios..."',
      integrate: 'Publicar',
      integrateTitle: 'Conecte e publique com governança',
      integrateDesc: 'Controle de acesso, logs e deploy por ambiente para entregar apps com confiança.',
      integrateBullet1: 'SSO e RBAC',
      integrateBullet2: 'Auditoria e logs',
      integrateBullet3: 'Deploy por ambiente',
      integrateBullet4: 'Webhooks e automações',
      integrateConnected: '3 conectores ativos',
    },
    // CTA New (Tyce-style)
    ctaNew: {
      title: 'Crie seu primeiro app com IA',
      subtitle: 'Gere UI, dados e automações em uma plataforma governada e pronta para produção.',
      getStarted: 'Começar agora',
      bookDemo: 'Agendar demo',
      downloadTitle: 'Crie, publique e itere mais rápido',
      downloadSubtitle: 'Conecte seus dados, gere um app e entregue com permissões e auditoria.',
    },
    // Footer
    footer: {
      product: 'Produto',
      features: 'Recursos',
      integrations: 'Integrações',
      pricing: 'Preços',
      company: 'Empresa',
      about: 'Sobre',
      blog: 'Blog',
      careers: 'Carreiras',
      resources: 'Recursos',
      documentation: 'Documentação',
      helpCenter: 'Central de ajuda',
      community: 'Comunidade',
      legal: 'Legal',
      privacy: 'Privacidade',
      terms: 'Termos de uso',
      security: 'Segurança',
      copyright: '© 2026 Paladino AI. Todos os direitos reservados.',
    },
    // Settings
    settings: {
      title: 'Configurações',
      language: 'Idioma',
      languageDesc: 'Escolha o idioma da interface',
      theme: 'Tema',
      themeDesc: 'Escolha o tema da interface',
      light: 'Claro',
      dark: 'Escuro',
      system: 'Sistema',
    },
    // Auth / Login
    auth: {
      welcome: 'Bem-vindo ao Paladino',
      subtitle: 'Entre na sua conta para continuar',
      email: 'Email',
      password: 'Senha',
      passwordPlaceholder: 'Sua senha',
      rememberMe: 'Lembrar-me',
      forgotPassword: 'Esqueceu a senha?',
      loginButton: 'Entrar',
      noAccount: 'Não tem uma conta?',
      signUp: 'Criar conta',
      loggingIn: 'Entrando...',
      invalidCredentials: 'Credenciais inválidas',
      loginError: 'Erro ao fazer login',
      waitlistRequired: 'Acesso restrito. Cadastre-se na lista de espera para continuar.',
      waitlistSubtitle: 'O login está disponível apenas para membros da lista de espera.',
      loginWithGoogle: 'Acessar com o Google',
      loginWithEmail: 'Entrar com e-mail',
      continueWithGoogle: 'Continuar com Google',
      continueWithApple: 'Continuar com Apple',
      accessWith: 'Acesse com',
      continue: 'Continuar',
      sendCode: 'Enviar código',
      back: 'Voltar',
      codeSentTo: 'Código enviado para',
      code: 'Código de 6 dígitos',
      useDifferentEmail: 'Usar outro e-mail',
      codeSent: 'Código enviado. Verifique seu e-mail.',
      termsOfUse: 'Termos de Uso',
      privacyPolicy: 'Política de Privacidade',
      emailPlaceholder: 'alisson@plenary.com.br',
      verificationCodeTitle: 'Enviamos um código de verificação',
      verificationCodeDescription: 'Insira o código de verificação que enviamos para',
      didntReceiveCode: 'Não recebeu o código?',
      resendCode: 'Re-enviar código',

    },
    // Sidebar
    sidebar: {
      newChat: 'Nova conversa',
      search: 'Buscar...',
      recent: 'Recente',
      favorites: 'Favoritos',
      spaces: 'Spaces',
      agents: 'Agentes',
      settings: 'Configurações',
      profile: 'Perfil',
      logout: 'Sair',
      today: 'Hoje',
      yesterday: 'Ontem',
      lastWeek: 'Última semana',
      older: 'Mais antigo',
      noChats: 'Nenhuma conversa ainda',
      startNewChat: 'Comece uma nova conversa',
      mainMenu: 'MENU PRINCIPAL',
      projects: 'SPACES',
      chat: 'Chat',
      workflows: 'Workflows',
      skills: 'Skills',
      createProject: 'Criar Projeto',
      projectName: 'Nome do projeto',
      projectDescription: 'Descrição (opcional)',
      create: 'Criar',
      cancel: 'Cancelar',
      newProject: 'Novo Projeto',
      defineNameDescription: 'Defina um nome e (se quiser) uma breve descrição.',
      close: 'Fechar',
      projectNamePlaceholder: 'Ex: Meu Novo Projeto',
      descriptionPlaceholder: 'Descreva o objetivo do projeto...',
      creating: 'Criando...',
      createProjectError: 'Não foi possível criar o projeto. Tente novamente.',
      onboarding: {
        projectType: "Qual é o tipo do seu projeto?",
        projectName: "Qual é o nome do seu projeto?",
        projectNameLabel: "Nome do projeto",
        projectNamePlaceholder: "ex: UI8 Studio Web Design",
        continue: "Continuar",
        previous: "Anterior",
        webApp: "Web app",
        uiDesign: "UI/UI Design",
        mobileApp: "Mobile app",
        brandingLogo: "Branding & logo",
        illustration: "Illustration",
        design3d: "3D Design",
      },
    },
    // Chat
    chat: {
      typeMessage: 'Digite uma mensagem...',
      send: 'Enviar',
      attachFile: 'Anexar arquivo',
      recording: 'Gravando...',
      stopRecording: 'Parar gravação',
      thinking: 'Pensando...',
      generating: 'Gerando resposta...',
      error: 'Erro ao enviar mensagem',
      retry: 'Tentar novamente',
      copy: 'Copiar',
      copied: 'Copiado!',
      delete: 'Excluir',
      edit: 'Editar',
      regenerate: 'Regenerar',
      selectAgent: 'Selecionar agente',
      noAgent: 'Nenhum agente selecionado',
      uploadFile: 'Enviar arquivo',
      maxFileSize: 'Tamanho máximo: 10MB',
      supportedFormats: 'Formatos suportados: PDF, DOC, DOCX, TXT',
    },
    // Dashboard
    dashboard: {
      welcome: 'Bem-vindo',
      overview: 'Visão geral',
      recentActivity: 'Atividade recente',
      quickActions: 'Ações rápidas',
      statistics: 'Estatísticas',
      noActivity: 'Nenhuma atividade recente',
      viewAll: 'Ver tudo',
      createNew: 'Criar novo',
      inbox: 'Caixa de entrada',
      myIssues: 'Minhas tarefas',
      workspace: 'Equipe',
      initiatives: 'Iniciativas',
      projects: 'Projetos',
      views: 'Visualizações',
      teams: 'Times',
      favorites: 'Favoritos',
      mobileApp: 'App Mobile',
      roadmap: 'Roadmap Q1',
      docs: 'Documentação',
      yourTeams: 'Seus Times',
      product: 'Produto',
      engineering: 'Engenharia',
      helpSupport: 'Ajuda e Suporte',
      addSubtasks: 'Adicionar sub-tarefas',
      links: 'Links',
      project: 'Projeto',
    },
    // Spaces
    spaces: {
      title: 'Spaces',
      description: 'Organize seus projetos e equipes',
      createSpace: 'Criar Space',
      mySpaces: 'Meus Spaces',
      allSpaces: 'Todos os Spaces',
      noSpaces: 'Nenhum space encontrado',
      members: 'Membros',
      projects: 'Projetos',
      settings: 'Configurações',
      delete: 'Excluir space',
      leave: 'Sair do space',
      invite: 'Convidar membros',
      spaceName: 'Nome do space',
      spaceDescription: 'Descrição',
      create: 'Criar',
      cancel: 'Cancelar',
    },
    // Agents
    agents: {
      title: 'Agentes',
      description: 'Gerencie seus agentes de IA',
      createAgent: 'Criar Agente',
      myAgents: 'Meus Agentes',
      allAgents: 'Todos os Agentes',
      noAgents: 'Nenhum agente encontrado',
      configure: 'Configurar',
      delete: 'Excluir',
      agentName: 'Nome do agente',
      agentType: 'Tipo de agente',
      agentDescription: 'Descrição',
      create: 'Criar',
      cancel: 'Cancelar',
    },
    // Common
    common: {
      save: 'Salvar',
      cancel: 'Cancelar',
      delete: 'Excluir',
      edit: 'Editar',
      create: 'Criar',
      update: 'Atualizar',
      search: 'Buscar',
      filter: 'Filtrar',
      sort: 'Ordenar',
      loading: 'Carregando...',
      error: 'Erro',
      success: 'Sucesso',
      warning: 'Atenção',
      info: 'Informação',
      confirm: 'Confirmar',
      yes: 'Sim',
      no: 'Não',
      back: 'Voltar',
      next: 'Próximo',
      finish: 'Concluir',
      close: 'Fechar',
    },
  },
  'en-US': {
    // Navbar
    nav: {
      features: 'Features',
      integrations: 'Integrations',
      pricing: 'Pricing',
      login: 'Login',
      getStarted: 'Get started',
    },
    // Hero
    hero: {
      title: 'Generate internal apps with AI',
      subtitle: 'From idea to app in minutes.',
      description: 'Describe what you need, connect your data, and ship with governance.',
      privacyTitle: 'Governance and control',
      privacyBlur: 'Security',
      privacySuffix: ' and compliance',
      privacyDesc: 'Permissions, auditing, and environment isolation. Your data stays yours — with full access control.',
      newFeature: 'New:',
      newFeatureText: 'AI app generation and connectors',
      buildAgentsBlur: 'Build it your way.',
      buildAgentsSuffix: '',
      buildAgentsDesc: 'Ship on a platform you can trust.',
      introducingMultiAgent: 'Get 50 credits',
      betaWithCredits: 'BETA',
    },
    // Logo Cloud
    logoCloud: {
      title: 'Powerful integrations for your workflow',
      subtitle: 'Connect with the tools your team already uses. ClickUp, GitHub, Slack, Jira and more.',
      cta: 'See all integrations',
    },
    // Perfect For Section
    perfectFor: {
      title: 'Apps for every team',
      items: {
        crm: 'CRM',
        report: 'Report',
        contracts: 'Contracts',
        website: 'Website',
        mobile: 'Mobile App',
        dashboards: 'Dashboards',
        marketing: 'Marketing',
        seo: 'SEO',
        sales: 'Sales',
        finance: 'Finance',
        hr: 'HR',
        onboarding: 'Onboarding',
        newsletter: 'Newsletter',
        blog: 'Blog',
        ecommerce: 'E-commerce',
        api: 'API',
        design_system: 'Design System',
        roadmap: 'Roadmap',
      },
    },
    // Integrations Section
    integrations: {
      title: 'Connect data, APIs, and tools',
      subtitle: 'Paladino connects your systems so AI can generate apps and automations with real context.',
      connectorTitle: 'Universal Connector',
      connectorDesc: 'Connect databases, APIs, and internal tools — with permissions and auditing.',
      connected: 'Connected',
      seeAll: 'See all integrations →',
    },
    // AI Section
    ai: {
      label: 'AI app builder',
      title: 'A studio to generate apps end-to-end',
      subtitle: 'From prompt to app.',
      description: 'Generate UI, queries, automations, and permissions — fully editable and production-ready.',
      learnMore: 'Learn more',
      assignTo: 'Assign to...',
      agent: 'Agent',
      selfDriving: 'Executable workflows',
      selfDrivingDesc: 'Automate approvals, syncs, and tasks with actionable steps.',
    },
    // Features
    features: {
      title: 'Built for teams that ship',
      subtitle: 'Everything you need to build internal apps and automations',
      prd: 'Apps and dashboards',
      prdDesc: 'Generate screens, tables, forms, and filters in minutes.',
      specs: 'Logic and integrations',
      specsDesc: 'Queries, APIs, webhooks, and actions connected to your stack.',
      proposals: 'Governance',
      proposalsDesc: 'SSO, RBAC, and audit logs for access control.',
      reports: 'Delivery',
      reportsDesc: 'Environments, versions, and deploy with confidence.',
    },
    // Product Direction
    productDirection: {
      label: 'Build and collaborate',
      title: 'Build, review, and ship with control',
      subtitle: 'Everything centralized in one place.',
      description: 'Model UI, logic, and data with real-time collaboration and change history.',
      manageProjects: 'Environments and versions',
      manageProjectsDesc: 'Separate dev, staging, and production with traceable changes.',
      projectUpdates: 'Real-time collaboration',
      projectUpdatesDesc: 'Edit screens and flows with your team without losing consistency.',
      ideate: 'From prompt to production',
      ideateSubtitle: 'on a single platform',
      collaborativeDocs: 'Collaborative components',
      inlineComments: 'Inline comments',
      textToIssue: 'Prompt to action',
      initiatives: 'Modules',
      initiativesDesc: 'Organize apps by modules and domains.',
      crossTeam: 'Cross-team collaboration',
      crossTeamDesc: 'Integrate teams from different areas.',
      milestones: 'Releases',
      milestonesDesc: 'Plan versions and ship safely.',
      insights: 'Observability',
      insightsDesc: 'Track logs, errors, and audit trails.',
    },
    // Workflows
    workflows: {
      label: 'Workflows and integrations',
      title: 'Connect',
      titleBreak: 'tools and data',
      description: 'Use connectors to generate apps with real data and actionable automations.',
      customerRequests: 'Internal requests',
      customerRequestsTitle: 'Turn requests into apps and flows',
      gitWorkflows: 'Git delivery',
      gitWorkflowsTitle: 'Version, review, and ship changes',
      mobile: 'Mobile App',
      mobileTitle: 'Access and operate from anywhere',
      asks: 'Approvals and SLAs',
      asksTitle: 'Automate steps with traceability',
    },
    // CTA
    cta: {
      title: 'Build apps. Ship with confidence.',
      contactSales: 'Contact sales',
      getStarted: 'Get started',
    },
    // Features New (Tyce-style)
    featuresNew: {
      title: 'How it works',
      search: 'Design',
      searchTitle: 'Design screens with prompts',
      searchDesc: 'Describe the flow and Paladino generates layout and components with consistency.',
      searchBullet1: 'Responsive, reusable layouts',
      searchBullet2: 'Data-ready components',
      searchBullet3: 'Design patterns and accessibility',
      searchBullet4: 'Full editability after generation',
      searchPlaceholder: 'Search components...',
      generate: 'Generate',
      generateTitle: 'Generate logic, queries, and actions',
      generateDesc: 'Create SQL queries, integrations, and validations based on your schema and rules.',
      generateBullet1: 'SQL and APIs with suggestions',
      generateBullet2: 'Validations and business rules',
      generateBullet3: 'Forms, tables, and filters',
      generateBullet4: 'Editable code and actions',
      generateDocTitle: 'New screen: onboarding',
      generateAuto: 'Auto-generated',
      analyze: 'Validate',
      analyzeTitle: 'Test and refine with AI',
      analyzeDesc: 'Simulate scenarios, catch edge cases, and improve UX, permissions, and performance.',
      analyzeBullet1: 'Flow tests and edge cases',
      analyzeBullet2: 'Permission and access review',
      analyzeBullet3: 'Performance suggestions',
      analyzeDocTitle: 'App review',
      analyzeComplete: 'Production-ready',
      analyzeSuggestion: '"Suggestion: add required-field validation..."',
      integrate: 'Ship',
      integrateTitle: 'Connect and ship with governance',
      integrateDesc: 'Access control, logs, and environment-based deploy to ship apps with confidence.',
      integrateBullet1: 'SSO and RBAC',
      integrateBullet2: 'Audit logs',
      integrateBullet3: 'Environment deploys',
      integrateBullet4: 'Webhooks and automations',
      integrateConnected: '3 connectors active',
    },
    // CTA New (Tyce-style)
    ctaNew: {
      title: 'Build your first app with AI',
      subtitle: 'Generate UI, data, and automations on a governed, production-ready platform.',
      getStarted: 'Get started',
      bookDemo: 'Book a demo',
      downloadTitle: 'Build, ship, and iterate faster',
      downloadSubtitle: 'Connect your data, generate an app, and deliver with permissions and auditing.',
    },
    // Footer
    footer: {
      product: 'Product',
      features: 'Features',
      integrations: 'Integrations',
      pricing: 'Pricing',
      company: 'Company',
      about: 'About',
      blog: 'Blog',
      careers: 'Careers',
      resources: 'Resources',
      documentation: 'Documentation',
      helpCenter: 'Help Center',
      community: 'Community',
      legal: 'Legal',
      privacy: 'Privacy',
      terms: 'Terms',
      security: 'Security',
      copyright: '© 2026 Paladino AI. All rights reserved.',
    },
    // Settings
    settings: {
      title: 'Settings',
      language: 'Language',
      languageDesc: 'Choose the interface language',
      theme: 'Theme',
      themeDesc: 'Choose the interface theme',
      light: 'Light',
      dark: 'Dark',
      system: 'System',
    },
    // Auth / Login
    auth: {
      welcome: 'Welcome back',
      subtitle: 'Sign in to your account to continue',
      email: 'Email',
      password: 'Password',
      passwordPlaceholder: 'Your password',
      rememberMe: 'Remember me',
      forgotPassword: 'Forgot password?',
      loginButton: 'Sign in',
      noAccount: "Don't have an account?",
      signUp: 'Sign up',
      loggingIn: 'Signing in...',
      invalidCredentials: 'Invalid credentials',
      loginError: 'Login error',
      waitlistRequired: 'Access restricted. Join the waitlist to continue.',
      waitlistSubtitle: 'Login is only available for waitlist members.',
      loginWithGoogle: 'Sign in with Google',
      loginWithEmail: 'Sign in with email',
      continueWithGoogle: 'Continue with Google',
      continueWithApple: 'Continue with Apple',
      accessWith: 'Access with',
      continue: 'Continue',
      sendCode: 'Send code',
      back: 'Back',
      codeSentTo: 'Code sent to',
      code: '6-digit code',
      useDifferentEmail: 'Use a different email',
      codeSent: 'Code sent. Check your email.',
      termsOfUse: 'Terms of Use',
      privacyPolicy: 'Privacy Policy',
      emailPlaceholder: 'alisson@plenary.com.br',
      verificationCodeTitle: 'We sent a verification code',
      verificationCodeDescription: 'Enter the verification code we sent to',
      didntReceiveCode: "Didn't receive the code?",
      resendCode: 'Resend code',
    },
    // Sidebar
    sidebar: {
      newChat: 'New chat',
      search: 'Search...',
      recent: 'Recent',
      favorites: 'Favorites',
      spaces: 'Spaces',
      agents: 'Agents',
      settings: 'Settings',
      profile: 'Profile',
      logout: 'Logout',
      today: 'Today',
      yesterday: 'Yesterday',
      lastWeek: 'Last week',
      older: 'Older',
      noChats: 'No chats yet',
      startNewChat: 'Start a new chat',
      mainMenu: 'MAIN MENU',
      projects: 'SPACES',
      chat: 'Chat',
      workflows: 'Workflows',
      skills: 'Skills',
      createProject: 'Create Project',
      projectName: 'Project name',
      projectDescription: 'Description (optional)',
      create: 'Create',
      cancel: 'Cancel',
      newProject: 'New Project',
      defineNameDescription: 'Define a name and (if you want) a brief description.',
      close: 'Close',
      projectNamePlaceholder: 'Ex: My New Project',
      descriptionPlaceholder: 'Describe the project goal...',
      creating: 'Creating...',
      createProjectError: 'Could not create project. Please try again.',
      onboarding: {
        projectType: "What's your type of project?",
        projectName: "What's the name of your project?",
        projectNameLabel: "Project name",
        projectNamePlaceholder: "e.g. UI8 Studio Web Design",
        continue: "Continue",
        previous: "Previous",
        webApp: "Web app",
        uiDesign: "UI/UI Design",
        mobileApp: "Mobile app",
        brandingLogo: "Branding & logo",
        illustration: "Illustration",
        design3d: "3D Design",
      },
    },
    // Chat
    chat: {
      typeMessage: 'Type a message...',
      send: 'Send',
      attachFile: 'Attach file',
      recording: 'Recording...',
      stopRecording: 'Stop recording',
      thinking: 'Thinking...',
      generating: 'Generating response...',
      error: 'Error sending message',
      retry: 'Try again',
      copy: 'Copy',
      copied: 'Copied!',
      delete: 'Delete',
      edit: 'Edit',
      regenerate: 'Regenerate',
      selectAgent: 'Select agent',
      noAgent: 'No agent selected',
      uploadFile: 'Upload file',
      maxFileSize: 'Max size: 10MB',
      supportedFormats: 'Supported formats: PDF, DOC, DOCX, TXT',
    },
    // Dashboard
    dashboard: {
      welcome: 'Welcome',
      overview: 'Overview',
      recentActivity: 'Recent activity',
      quickActions: 'Quick actions',
      statistics: 'Statistics',
      noActivity: 'No recent activity',
      viewAll: 'View all',
      createNew: 'Create new',
      inbox: 'Inbox',
      myIssues: 'My Issues',
      workspace: 'Workspace',
      initiatives: 'Initiatives',
      projects: 'Projects',
      views: 'Views',
      teams: 'Teams',
      favorites: 'Favorites',
      mobileApp: 'Mobile App',
      roadmap: 'Q1 Roadmap',
      docs: 'Documentation',
      yourTeams: 'Your Teams',
      product: 'Product',
      engineering: 'Engineering',
      helpSupport: 'Help & Support',
      addSubtasks: 'Add sub-tasks',
      links: 'Links',
      project: 'Project',
    },
    // Spaces
    spaces: {
      title: 'Spaces',
      description: 'Organize your projects and teams',
      createSpace: 'Create Space',
      mySpaces: 'My Spaces',
      allSpaces: 'All Spaces',
      noSpaces: 'No spaces found',
      members: 'Members',
      projects: 'Projects',
      settings: 'Settings',
      delete: 'Delete space',
      leave: 'Leave space',
      invite: 'Invite members',
      spaceName: 'Space name',
      spaceDescription: 'Description',
      create: 'Create',
      cancel: 'Cancel',
    },
    // Agents
    agents: {
      title: 'Agents',
      description: 'Manage your AI agents',
      createAgent: 'Create Agent',
      myAgents: 'My Agents',
      allAgents: 'All Agents',
      noAgents: 'No agents found',
      configure: 'Configure',
      delete: 'Delete',
      agentName: 'Agent name',
      agentType: 'Agent type',
      agentDescription: 'Description',
      create: 'Create',
      cancel: 'Cancel',
    },
    // Common
    common: {
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      create: 'Create',
      update: 'Update',
      search: 'Search',
      filter: 'Filter',
      sort: 'Sort',
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
      warning: 'Warning',
      info: 'Info',
      confirm: 'Confirm',
      yes: 'Yes',
      no: 'No',
      back: 'Back',
      next: 'Next',
      finish: 'Finish',
      close: 'Close',
    },
  },
};

export type TranslationKey = keyof typeof translations['pt-BR'];
export type Locale = keyof typeof translations;
